// eg. 19 -> 20; -25 -> -20
function upTo10(i) {
  return Math.ceil(i / 10) * 10;
}

// eg. 19 -> 10; -25 -> -30
function downTo10(i) {
  return Math.floor(i / 10) * 10;
}

export default {
  upTo10,
  downTo10,
};



// WEBPACK FOOTER //
// ./src/components/singleClusterProjectionsLineGraph/roundNumber.js